import toQueryString from 'ROOT/src/action/Base/toQueryString';

export default class rest {
    constructor(parent) {
        this.url = parent.param.server;
        this.token = null;
        this.parent = parent;
        this.xhr = null;
        this.controller = null;
    }

    post(action, data, complete, cancelPrevisouRequest = true) {
        this.call(
            action,
            'POST',
            data,
            function(msg) {
                complete(msg);
            },
            cancelPrevisouRequest,
        );
    }
    get(action, complete, cancelPrevisouRequest = true) {
        this.call(
            action,
            'GET',
            null,
            function(msg) {
                complete(msg);
            },
            cancelPrevisouRequest,
        );
    }
    delete(action, data, complete) {
        this.call(action, 'DELETE', data, function(msg) {
            complete(msg);
        });
    }
    call(action, method, data, complete, cancelPreviousRequest) {
        const self = this;
        const auth = this.getAuth();

        if (this.xhr !== null && cancelPreviousRequest === true) {
            this.controller.abort();
            this.controller = null;
        }
        this.controller = new AbortController();

        if (this.parent?.param?.xdebugEnabled) {
            action += (action?.includes('?') ? '&' : '?') + 'XDEBUG_SESSION_START=1';
        }

        const headersData = {
            'content-type': 'application/json',
            // 'sId': auth.sID
        };

        // adds check sid and other parameters from auth to headers
        Object.entries(auth).forEach(([key, value]) => {
            if (key !== 'sID' && !self.parent.param.is_portal) {
                return;
            }
            headersData[key] = value;
        });

        if (this.parent.param.is_portal) {
            headersData.company = this.parent.param.portalCompany;
            headersData.language = this.getCookie('language');
        }

        const settings = {
            method: method,
            contentType: 'application/json',
            headers: new Headers(headersData),
            signal: this.controller.signal,
        };

        if (method === 'POST' || method === 'DELETE') {
            settings.body = JSON.stringify(data);
        }

        this.xhr = fetch( self.url + '/' + action, settings)
            .then((response) => this.checkResponse(response, action, self)).then((data) => {
                if (typeof data === 'object' && data.status === 'error') {
                    if (data.reason != undefined) {
                        self.parent.dsClear();
                        if (self.parent.dataGet('rightPanel/show') == true) {
                            self.parent.dsAdd('set', 'rightPanel/content', 'error');
                            self.parent.dsAdd('set', 'conf/load', false);
                            self.parent.dsAdd('set', 'rightPanel/data', {
                                state: false,
                                type: data.reason,
                            });
                        } else {
                            self.parent.dsAdd('set', 'conf/view', 'error');
                            self.parent.dsAdd('set', 'conf/load', false);
                            self.parent.dsAdd('set', 'view', {
                                state: false,
                                type: data.reason,
                            });
                        }

                        self.parent.dsProcess();
                    } else {
                        self.parent.unLoad();
                        self.parent.error(self.parent.translate(data.msg || data.message));
                    }
                }
                complete(data);
                if (typeof data === 'object' && data.status === 'warning') {
                    setTimeout(function() {
                        self.parent.error(self.parent.translate(data.msg || data.message));
                    }, 2500);
                }
            }).catch((responseError) => {
                console.log(responseError);
            });
    }
    checkResponse(response, action, self) {
        if (
            ((response.status == '401' || response.status == 0) && response.statusText != 'abort') &&
        action !== 'getNotifyCount' && action !== 'recalcTopRecent'
        ) {
            if (!window.location.hash.startsWith('#login')) {
                if (response.status == '401') {
                    clearInterval(this.parent.notificationInterval);

                    self.parent.routeLogin();
                } else {
                    self.parent.error(self.parent.translate('LBL_SERVER_ERROR'));
                    self.parent.unLoad();
                }
            } else {
                clearInterval(this.parent.notificationInterval);

                self.parent.routeLogin();
            }
        }
        return response.json();
    }


    getAuth() {
        const token = this.getCookie('sID');
        const auth = {
            sID: token,
        };

        if (this.parent.deviceType != undefined) {
            auth['device'] = this.parent.deviceType;
        }
        auth['deviceDesc'] = JSON.stringify(this.getDevice());
        return auth;
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + '; ' + expires;
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return null;
    }

    /**
     * Metoda pocita s formatem dat v coripo standardu, jinak nebude fungovat spravne.
     * @param {string} action
     * @param {string} method
     * @param {null|any} data
     * @param {boolean} cancelPreviousRequest
     * @return {Promise<any>}
     */
    async fetchData(action, method, data = null, cancelPreviousRequest = true) {
        const self = this;
        const sId = this.getAuth();
        let url = self.url + '/' + action;
        if (this.parent?.param?.xdebugEnabled) {
            url += (action?.includes('?') ? '&' : '?') + 'XDEBUG_SESSION_START=1';
        }

        if (this.controller && cancelPreviousRequest) {
            this.controller.abort();
        }

        this.controller = new AbortController();

        const headersData = {
            'content-type': 'application/json',
            'sId': sId.sID,
        };

        if (this.parent.param.is_portal) {
            headersData.company = this.parent.param.portalCompany;
        }

        const fetchParams = {
            method: method,
            contentType: 'application/json',
            signal: this.controller.signal,
            headers: new Headers(headersData),
        };

        if (['POST', 'PUT', 'PATCH'].includes(method) && data) {
            fetchParams.body = JSON.stringify(data);
        } else if (data) {
            url += toQueryString(data) ?? '';
        }

        const fetchedData = await fetch(url, fetchParams).then((response) => response.json()).then((result) => {
            return result;
        }).catch((responseError) => {
            switch (responseError.name) {
                case 'AbortError':
                    console.warn(`Request ${action} canceled`);
                    break;
                default:
                    this.parent.unLoad();
                    console.error('Error', responseError);
                    console.warn('You propably have error in your BE method returned data is not valid JSON');
            }
        });

        if (!fetchedData?.status) {
            throw fetchedData?.errorMessage;
        }

        return fetchedData.message;
    }

    getDevice() {
        if (this.browserInfo != null) {
            return this.browserInfo;
        }
        const unknown = 'Unknown';

        // screen
        let screenSize = '';
        if (screen.width) {
            const width = (screen.width) ? screen.width : '';
            const height = (screen.height) ? screen.height : '';
            screenSize += '' + width + ' x ' + height;
        }

        // browser
        const nVer = navigator.appVersion;
        const nAgt = navigator.userAgent;
        let browser = navigator.appName;
        let version = '' + parseFloat(navigator.appVersion);
        let majorVersion = parseInt(navigator.appVersion, 10);
        let nameOffset; let verOffset; let ix;

        // Opera
        if ((verOffset = nAgt.indexOf('Opera')) != -1) {
            browser = 'Opera';
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // MSIE
        else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(verOffset + 5);
        }

        // IE 11 no longer identifies itself as MS IE, so trap it
        // http://stackoverflow.com/questions/17907445/how-to-detect-ie11
        else if ((browser == 'Netscape') && (nAgt.indexOf('Trident/') != -1)) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(verOffset + 5);
            if ((verOffset = nAgt.indexOf('rv:')) != -1) {
                version = nAgt.substring(verOffset + 3);
            }
        }

        // Chrome
        else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
            browser = 'Chrome';
            version = nAgt.substring(verOffset + 7);
        }
        // Safari
        else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
            browser = 'Safari';
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                version = nAgt.substring(verOffset + 8);
            }

            // Chrome on iPad identifies itself as Safari. Actual results do not match what Google claims
            //  at: https://developers.google.com/chrome/mobile/docs/user-agent?hl=ja
            //  No mention of chrome in the user agent string. However it does mention CriOS, which presumably
            //  can be keyed on to detect it.
            if (nAgt.indexOf('CriOS') != -1) {
                // Chrome on iPad spoofing Safari...correct it.
                browser = 'Chrome';
                // Don't believe there is a way to grab the accurate version number, so leaving that for now.
            }
        }
        // Firefox
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
            browser = 'Firefox';
            version = nAgt.substring(verOffset + 8);
        }
        // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() == browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

        majorVersion = parseInt('' + version, 10);
        if (isNaN(majorVersion)) {
            version = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        let cookieEnabled = (navigator.cookieEnabled) ? true : false;

        if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
        }

        // system
        let os = unknown;
        const clientStrings = [
            {s: 'Windows 3.11', r: /Win16/},
            {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
            {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
            {s: 'Windows 98', r: /(Windows 98|Win98)/},
            {s: 'Windows CE', r: /Windows CE/},
            {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
            {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
            {s: 'Windows Server 2003', r: /Windows NT 5.2/},
            {s: 'Windows Vista', r: /Windows NT 6.0/},
            {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
            {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
            {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
            {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
            {s: 'Windows ME', r: /Windows ME/},
            {s: 'Android', r: /Android/},
            {s: 'Open BSD', r: /OpenBSD/},
            {s: 'Sun OS', r: /SunOS/},
            {s: 'Linux', r: /(Linux|X11)/},
            {s: 'iOS', r: /(iPhone|iPad|iPod)/},
            {s: 'Mac OS X', r: /Mac OS X/},
            {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
            {s: 'QNX', r: /QNX/},
            {s: 'UNIX', r: /UNIX/},
            {s: 'BeOS', r: /BeOS/},
            {s: 'OS/2', r: /OS\/2/},
            {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/},
        ];
        for (const id in clientStrings) {
            if (id) {
                const cs = clientStrings[id];
                if (cs.r.test(nAgt)) {
                    os = cs.s;
                    break;
                }
            }
        }


        let osVersion = unknown;

        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os)[1];
            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS X':
                osVersion = /Mac OS X ([\.\_\d]+)/.exec(nAgt)[1];
                break;

            case 'Android':
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                break;
        }
        const browserInfo = {
            screen: screenSize,
            browser: browser,
            browserVersion: version,
            mobile: mobile,
            os: os,
            osVersion: osVersion,
            cookies: cookieEnabled,
        };
        return browserInfo;
    }
}
